import { Cell } from 'common/types/scalarSpreadsheet';
import { ValuationMethodReverseParserParams } from './types';

const reverseParserValuationMethodsDetail = (params: ValuationMethodReverseParserParams) => {
  const { cells, tableData } = params;
  const column = tableData.columns[0];

  const getValue = (cell: Cell) => String(cell?.value ?? '0');

  column.weighted_market_enterprise_value = getValue(cells.A3);
  column.less_debt = getValue(cells.A4);
  column.weighted_equity_value = getValue(cells.A5);
  column.equity_allocation_summary = getValue(cells.A7);
  column.marketable_value_per_common_share = getValue(cells.A8);
  column.discount_for_lack_of_marketability = getValue(cells.A9);
};

export default reverseParserValuationMethodsDetail;
